import dayjs from 'dayjs';

export const bitacoraNotificacionDTO = (bitacoraNotDatos) => {
  return {
    asociado: bitacoraNotDatos.asociado,
    tipoActa: bitacoraNotDatos.tipoActa,
    aNotificar: bitacoraNotDatos.anotificar,
    notificadosAnteriores: bitacoraNotDatos.notificadosAnteriores,
    notificados: bitacoraNotDatos.notificados,
    correos: bitacoraNotDatos.correos,
    fechaHoraEnvio: dayjs(bitacoraNotDatos.fechaHoraEnvio, 'YYYYMMDDHHmmss').locale('es'),
    fechaHoraEnvioCadena: bitacoraNotDatos.fechaHoraEnvioCadena,
    nombre: bitacoraNotDatos.nombre,
    sujetoObligado: bitacoraNotDatos.sujetoObligado,
    usuario: bitacoraNotDatos.usuario,
    fechaHora: dayjs(bitacoraNotDatos.fechaHora, 'YYYYMMDDHHmmss').locale('es'),
    fechaHoraCadena: bitacoraNotDatos.fechaHoraCadena
  };
};
